import { AbstractJSONModel } from "./master-model";
export interface IPool {
  id: number;
  name: string;
  hours: number;
  employment_id: number;
  is_school_hour_pool: boolean;
  locked: boolean;
  created_at: Date;
  updated_at: Date;
  employee_id: number;
  consumption: number;
}

export interface IPoolPost {
  name: string;
  hours: number;
  employment_id: number;
  is_school_hour_pool: boolean;
  locked: boolean;
}

export interface IPoolPut {
  id: number;
  name: string;
  hours: number;
  is_school_hour_pool: boolean;
  locked: boolean;
}

export class Pool extends AbstractJSONModel implements IPool {
  public id = 0;
  public name = "";
  public hours = 0;
  public employment_id = 0;
  public is_school_hour_pool = false;
  public locked = false;
  public created_at: Date = new Date();
  public updated_at: Date = new Date();
  public employee_id = -1;
  public consumption = 0;

  public restTime(): number {
    return this.hours - this.consumption;
  }

  public convertToPostObject(): IPoolPost {
    const p: IPoolPost = Object.assign({});
    p.employment_id = this.employment_id;
    p.hours = this.hours;
    p.is_school_hour_pool = this.is_school_hour_pool;
    p.locked = this.locked;
    p.name = this.name;
    return p;
  }

  public convertToPutObject(): IPoolPut {
    const p: IPoolPut = Object.assign({});
    p.id = this.id;
    p.hours = this.hours;
    p.is_school_hour_pool = this.is_school_hour_pool;
    p.locked = this.locked;
    p.name = this.name;
    if (p.id < 1) {
      throw new Error("Id must be set to a positive number");
    }
    return p;
  }

  equals(other: IPool): boolean {
    return other.id === this.id;
  }

  public;
}
